export const useApplicationBuildType = (): { isDevelopment: boolean; isNotDevelopment: boolean } => {
  const isDevelopment = process?.env?.NODE_ENV == 'development';
  return { isDevelopment, isNotDevelopment: !isDevelopment };
};
